import React from 'react';
import styles from '../styles/PtSubscriptionPlanSection.scss';

type SubscriptionPlanProps = {
  title?: string;
  status?: React.ReactNode;
  statusInfo?: string;
  includesTitle?: string;
  includesSubtitle?: string;
  includesText?: string[];
  extraInfoTitle?: string;
  extraInfoText?: string;
  button?: React.ReactNode;
  icon?: React.ReactNode;
};

const PtSubscriptionPlanSection: React.FC<SubscriptionPlanProps> = ({
  title,
  status,
  statusInfo,
  includesTitle,
  includesSubtitle,
  includesText,
  extraInfoTitle,
  extraInfoText,
  button,
  icon,
}) => {
  return (
    <div className={styles.section}>
      <div className={styles.title}>{title}</div>
      <div className={styles.statusContainer}>
        <div className={styles.status}>{status}</div>
        <div className={styles.iconWrapper}>{icon}</div>
      </div>
      <div className={styles.statusInfo}>{statusInfo}</div>
      <div className={styles.includesAndExtraContainer}>
        <div className={styles.includesTitle}>{includesTitle}</div>
        <div className={styles.includesSubtitle}>{includesSubtitle}</div>
        <div>
          {includesText?.map((text) => (
            <div className={styles.includesText}>{text}</div>
          ))}
        </div>
        <div className={styles.extraInfoTitle}>{extraInfoTitle}</div>
        <div className={styles.extraInfoText}>{extraInfoText}</div>
      </div>
      <div className={styles.buttonContainer}>{button}</div>
    </div>
  );
};

export default PtSubscriptionPlanSection;
